/* Product page: gallery, variant picker (price, availability, image, URL), sticky add to cart. */
(function () {
  'use strict';
  var ST = window.ST || {};
  function money(cents) {
    var fmt = ST.money || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  document.querySelectorAll('[data-product]').forEach(function (root) {
    /* ---------- Gallery ---------- */
    var slides = Array.prototype.slice.call(root.querySelectorAll('.pdp-slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var index = 0;
    function show(i) {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.hidden = k !== index; s.classList.toggle('is-active', k === index); var v = s.querySelector('video'); if (v && k !== index) v.pause(); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === index); t.setAttribute('aria-selected', k === index); if (k === index) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = root.querySelector('[data-gallery-prev]'), next = root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    var stage = root.querySelector('.pdp-stage');
    if (stage) {
      var sx = 0, sy = 0;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? index + 1 : index - 1); }, { passive: true });
    }
    function showMedia(id) { var k = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); }); if (k > -1) show(k); }

    /* ---------- Variants ---------- */
    var picker = root.querySelector('[data-variant-picker]');
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var atc = root.querySelector('[data-atc]'), atcLabel = root.querySelector('[data-atc-label]');
    var priceNow = root.querySelector('.pdp-price [data-price-now]'), priceWas = root.querySelector('.pdp-price [data-price-was]'), priceSave = root.querySelector('.pdp-price [data-price-save]'), priceWrap = root.querySelector('.pdp-price [data-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    if (picker) {
      var variants = [];
      try { variants = JSON.parse(picker.querySelector('[data-variants]').textContent); } catch (e) {}
      function selected() {
        var opts = [];
        picker.querySelectorAll('input[type=radio]:checked').forEach(function (r) { opts[parseInt(r.dataset.optionIndex, 10)] = r.value; });
        return opts;
      }
      function markAvailability(opts) {
        picker.querySelectorAll('input[type=radio]').forEach(function (r) {
          var i = parseInt(r.dataset.optionIndex, 10);
          var test = opts.slice(); test[i] = r.value;
          var match = variants.find(function (v) { return v.options.every(function (o, k) { return k > i ? true : o === test[k]; }); });
          var any = variants.some(function (v) { return v.options.every(function (o, k) { return k > i ? true : o === test[k]; }) && v.available; });
          r.nextElementSibling.classList.toggle('is-unavailable', !any && !!match);
        });
      }
      function apply() {
        var opts = selected();
        var v = variants.find(function (vv) { return vv.options.every(function (o, k) { return o === opts[k]; }); });
        opts.forEach(function (o, k) { var l = picker.querySelector('[data-option-label="' + k + '"]'); if (l) l.textContent = o; });
        markAvailability(opts);
        if (!v) {
          if (atc) { atc.disabled = true; atcLabel.textContent = ST.strings.unavailable; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (atc) { atc.disabled = !v.available; atcLabel.textContent = v.available ? ST.strings.addToCart : ST.strings.soldOut; }
        if (priceNow) priceNow.textContent = money(v.price);
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        if (priceWrap) {
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          priceWrap.classList.toggle('is-sale', !!sale);
          if (priceWas) { priceWas.textContent = sale ? money(v.compare_at_price) : ''; priceWas.hidden = !sale; }
          if (priceSave) { priceSave.hidden = !sale; if (sale) priceSave.textContent = 'Save ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
        }
        if (v.featured_media) showMedia(v.featured_media.id);
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        var stock = root.querySelector('[data-stock]');
        if (stock) stock.innerHTML = v.available ? '<span class="card-stock">' + stock.dataset.inStock + '</span>' : '<span class="card-stock is-out">' + ST.strings.soldOut + '</span>';
      }
      picker.addEventListener('change', apply);
      var stock0 = root.querySelector('[data-stock]'); if (stock0) stock0.dataset.inStock = (stock0.textContent || '').trim();
      markAvailability(selected());
    }

    /* ---------- "Fits your car": compares the picker choice remembered in localStorage (st_fit) with this product's year and model tags ---------- */
    var fitBox = root.querySelector('[data-fit-years], [data-fit-models]');
    var fitYou = root.querySelector('[data-fit-you]');
    if (fitBox && fitYou) {
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem('st_fit') || 'null'); } catch (e) {}
      if (saved && saved.label) {
        var want = String(saved.label).toUpperCase();
        var years = (fitBox.dataset.fitYears || '').split(',').filter(Boolean);
        var models = (fitBox.dataset.fitModels || '').split(',').map(function (m) { return m.trim().toUpperCase(); }).filter(Boolean);
        var yearOk = !years.length || years.indexOf(String(saved.y)) !== -1;
        var modelOk = !models.length || models.some(function (m) { return want.indexOf(m) !== -1; });
        var ok = yearOk && modelOk;
        fitYou.querySelector('[data-ico-yes]').hidden = !ok;
        fitYou.querySelector('[data-ico-no]').hidden = ok;
        fitYou.querySelector('[data-fit-text]').textContent = (ok ? fitYou.dataset.yes : fitYou.dataset.no).replace('__CAR__', saved.label);
        fitYou.classList.toggle('is-warn', !ok);
        fitYou.hidden = false;
      }
    }

    /* ---------- Best review under the rating: read from the Judge.me widget once it has rendered ---------- */
    var best = root.querySelector('[data-best-review]');
    if (best) {
      var filled = false;
      function reviewsOnPage() {
        var out = [];
        document.querySelectorAll('.jm-review-item').forEach(function (it) {
          var label = (it.querySelector('.jm-star-rating') || {}).getAttribute ? it.querySelector('.jm-star-rating').getAttribute('aria-label') || '' : '';
          var m = label.match(/(\d+(?:\.\d+)?)/);
          var body = (it.querySelector('.jm-review-content__body') || {}).textContent || '';
          out.push({ rating: m ? parseFloat(m[1]) : 0, body: body.replace(/\s*More\s*$/, '').replace(/\s+/g, ' ').trim(), author: ((it.querySelector('.jm-reviewer-info__name') || {}).textContent || '').trim(), verified: !!it.querySelector('.jm-verified-buyer-badge') });
        });
        document.querySelectorAll('.jdgm-rev').forEach(function (it) {
          var r = it.querySelector('.jdgm-rev__rating'); var b = it.querySelector('.jdgm-rev__body');
          out.push({ rating: r ? parseFloat(r.getAttribute('data-score') || '0') : 0, body: (b ? b.textContent : '').replace(/\s+/g, ' ').trim(), author: ((it.querySelector('.jdgm-rev__author') || {}).textContent || '').trim(), verified: !!it.querySelector('.jdgm-rev__buyer-badge') });
        });
        return out.filter(function (r) { return r.body.length > 20; });
      }
      function fillBest() {
        if (filled) return true;
        var list = reviewsOnPage(); if (!list.length) return false;
        list.sort(function (a, b) { return (b.rating - a.rating) || (b.body.length - a.body.length); });
        var r = list[0];
        if (r.rating < 4) return true; /* nothing worth quoting */
        var text = r.body.length > 220 ? r.body.slice(0, 217).replace(/\s+\S*$/, '') + '\u2026' : r.body;
        best.querySelector('[data-best-stars]').textContent = '\u2605'.repeat(Math.round(r.rating)) + '\u2606'.repeat(5 - Math.round(r.rating));
        best.querySelector('[data-best-text]').textContent = '\u201C' + text + '\u201D';
        best.querySelector('[data-best-author]').textContent = r.author || '';
        best.querySelector('[data-best-verified]').hidden = !r.verified;
        var link = best.querySelector('[data-best-link]');
        var count = document.querySelectorAll('.jm-review-item, .jdgm-rev').length;
        var countEl = document.querySelector('.pdp-rating-link .mono');
        var totalMatch = countEl ? (countEl.textContent.match(/(\d+)\s*review/) || [])[1] : null;
        link.textContent = (link.dataset.label || 'Read all reviews').replace('__COUNT__', totalMatch || String(count));
        best.hidden = false; filled = true; return true;
      }
      if (!fillBest() && 'MutationObserver' in window) {
        var mo = new MutationObserver(function () { if (fillBest()) mo.disconnect(); });
        mo.observe(document.body, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 15000);
      }
    }

    /* ---------- Sticky add to cart (phones) ---------- */
    var sticky = root.querySelector('[data-sticky-atc]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var io = new IntersectionObserver(function (entries) { sticky.classList.toggle('is-on', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0); }, { threshold: 0 });
      io.observe(atc);
      var trig = sticky.querySelector('[data-sticky-trigger]');
      if (trig) trig.addEventListener('click', function () { if (!atc.disabled) atc.click(); else window.ST.scrollTo(form, -120); });
      document.addEventListener('st:cart:added', function () { sticky.classList.remove('is-on'); setTimeout(function () { sticky.classList.add('is-on'); }, 2500); });
    }
  });
})();
